'use strict';

module.exports = function (refToEdit, e) {

  console.log(refToEdit);
  console.log('after');
  console.log(this.opts.cellToEdit);
  this.opts.cellToEdit = this.opts.cellToEdit.filter(function (el) {
    return typeof el === 'String' && el !== refToEdit;
  });
  console.log('before');
  console.log(this.opts.cellToEdit);

  this.$forceUpdate();
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/cancel-cell-edit.js